import { Col, Form, message, Modal, Row, Typography } from "antd";
import GeneralPhoneNumber2 from "apps/Common/GeneralPhoneNumber2";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { formatPhoneNumber } from "helpers/ConvertPhoneFormat";
import useMazakaForm from "hooks/useMazakaForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import AddOrUpdateProfileImage from "./AddOrUpdateImageProfile";
import DeleteAccount from "./DeleteAccount";
import { updateProfileInfoes, uploadProfileImage } from "../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { handleSetUserInfoes } from "../ClientSideStates";
import ConfirmLoginCode from "apps/Account/Pages/ConfirmCode/ConfirmCode";
import { getSMSVerifyCode } from "apps/Account/Services";
import { UploadFile } from "antd/lib";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

const GeneralInfoes = () => {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const [isShowConfirmCode, setIsShowConfirmCode] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [phoneNumber, setPhoneNumber] = useState({
    numberPrefix: "",
    numberBody: "",
  });
  const dispatch = useDispatch();
const [showVerifyModal, setShowVerifyModal] = useState(false);



useEffect(() => {
  if (!userInfoes?.verificationCode) {
    setShowVerifyModal(true);
  }
}, [userInfoes]);

const handleSendVerificationCode = async () => {
  setShowVerifyModal(false);
  setIsShowConfirmCode(true);
   const response = await getSMSVerifyCode(userInfoes.numberPrefix, userInfoes.phoneNumber);
   await setPhoneNumber({
        numberPrefix: userInfoes.numberPrefix,
        numberBody: userInfoes.phoneNumber,
      });
    setIsShowConfirmCode(true);
};


  const formatPhoneNumber = (input: string) => {
    const regex = /^90(\d{3})(\d{7})$/;
    return input.replace(regex, "90+$1$2");
  };

  useEffect(() => {
    let data = { ...userInfoes };
    let unFormatedPhone = `${userInfoes?.numberPrefix + userInfoes?.phoneNumber
      }`;
    let phone = formatPhoneNumber(unFormatedPhone);

    if (userInfoes?.numberPrefix && userInfoes?.phoneNumber) {
      data["Phone"] = phone;
    }
    form.setFieldsValue({
      ...data,
    });
  }, [userInfoes]);

  const stausChangedPhoneNumber = (
    numberPrefix: string,
    numberBody: string
  ) => {
    if (
      userInfoes?.numberPrefix === numberPrefix &&
      userInfoes?.phoneNumber === numberBody
    ) {
      return false;
    }
    return true;
  };

  const updateProfileInformations = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    let split_number = formValues["Phone"].includes("+")
      ? formValues["Phone"].split("+")
      : formatPhoneNumber(formValues["Phone"]).split("+");

    let numberPrefix = split_number[0];
    let numberBody = split_number[1];


    const data = {
       ...userInfoes,
      ...formValues,
      numberPrefix,
      phoneNumber: numberBody,
      id: userInfoes.id,
    };

    delete data["Phone"];
    try {
      const response = await updateProfileInfoes(data);

      dispatch(handleSetUserInfoes({ data: response?.data || {} }))
      mazakaForm.setSuccess(1000, () => response?.message);
    } catch (error: any) {
      mazakaForm.setFailed(
        2000,
        error?.message || "Bilinmeyen bir hata oluştu"
      );

      console.log("Somethings wrong during updateing profile infoes", error);
    }
  };



  const handleOnFinish = async () => {
    let formValues = form.getFieldsValue();

    mazakaForm.setLoading();

    let split_number = formValues["Phone"].includes("+")
      ? formValues["Phone"].split("+")
      : formatPhoneNumber(formValues["Phone"]).split("+");
    let numberPrefix = split_number[0];
    let numberBody = split_number[1];

    const data = { ...formValues, numberPrefix, numberBody };
    delete data["Phone"];
    const isChangePhone = stausChangedPhoneNumber(numberPrefix, numberBody);

    if (isChangePhone) {
      try {
        const response = await getSMSVerifyCode(numberPrefix, numberBody);
        mazakaForm.setSuccess(1000, () => "işlemi Başarılı");
        openNotificationWithIcon("default", response?.message || "");
        await setPhoneNumber({
          numberPrefix,
          numberBody,
        });
        setIsShowConfirmCode(true);
      } catch (error: any) {
        mazakaForm.setFailed(
          2000,
          error?.message || "Bilinmeyen bir hata oluştu"
        );
        openNotificationWithIcon("default", error?.message || "");

        console.log("Somethings wrong during login to dashboard", error);
      }
    } else {
      updateProfileInformations();
    }
  };

  return (
    <>
      <Col xs={24}>
        <Helmet>
          <title className="capitalize">{"Profil"}</title>
        </Helmet>
        <MazakaForm
          form={form}
          submitButtonVisible={false}
          onFinish={handleOnFinish}
        >
          <Row

            gutter={[
              { xs: 0, md: 10, xl: 10 },
              { xs: 0, md: 15, xl: 20 }
            ]}
          >
            {/* <Col span={24} className="!flex justify-center">
            <PageTitle
            title={"Profil"}
            />
             
            </Col> */}

            <Col xs={24} className="!flex justify-center lg:!block" >
              <AddOrUpdateProfileImage type={"profile"} fileList={fileList} setFileList={setFileList} />
            </Col>

            <MazakaInput
              label="İsim"
              placeholder="İsim"
              xs={24}
              name={"name"}
              size="large"
            />
            <MazakaInput
              label="Soyisim"
              placeholder="Soyisim"
              xs={24}
              name={"surname"}
              size="large"
              rules={[{ required: true, message: "" }]}
            />

            <MazakaInput
              label="E-Posta"
              placeholder="E-Posta"
              name="eMail"
              size="large"
              xs={24}
              rules={[
                {
                  type: "email",
                  message: "E-Posta Formatı Geçersiz",
                },
                { required: true, message: "" },
              ]}
            />
            <GeneralPhoneNumber2
              label={"Telefon Numarası"}
              name="Phone"
              required={true}
              xs={24}
              form={form}
              placeholder={"Telefon Numarası"}
              inputClass="!m-0  !h-[39px] !text-black"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            />

            <Col span={24} className="!flex justify-between !items-center ">
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black !mt-4"
                htmlType="submit"
                processType={formActions.submitProcessType}
              >
                Kaydet
              </MazakaButton>
              <DeleteAccount />
            </Col>
          </Row>
        </MazakaForm>
      </Col>
      <Modal
        open={isShowConfirmCode}
        onCancel={() => {
          setIsShowConfirmCode(false);
        }}
        footer={false}
        title={false}
      >
        <ConfirmLoginCode
          setIsShowConfirmCode={setIsShowConfirmCode}
          numberPrefix={phoneNumber.numberPrefix}
          numberBody={phoneNumber.numberBody}
          onFinish={updateProfileInformations}
          pageType="profile"
        />
      </Modal>
      <></>
      <Modal
  open={showVerifyModal}
  onCancel={() => setShowVerifyModal(false)}
  footer={null}
  title="Telefon Numaranızı Doğrulayın"
>
  <Typography.Text>
    Telefon numaranız doğrulanmamış. Doğrulama kodu göndermek ister misiniz?
  </Typography.Text>
  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
    <MazakaButton
      className="!mr-2"
      onClick={() => setShowVerifyModal(false)}
    >
      İptal
    </MazakaButton>
    <MazakaButton
      className="!bg-[#FFC502] !text-black"
      onClick={handleSendVerificationCode}
    >
      Gönder
    </MazakaButton>
  </div>
</Modal>

<Modal
  open={isShowConfirmCode}
  onCancel={() => setIsShowConfirmCode(false)}
  footer={false}
  title={false}
>
  <ConfirmLoginCode
    setIsShowConfirmCode={setIsShowConfirmCode}
    numberPrefix={userInfoes.numberPrefix}
    numberBody={userInfoes.phoneNumber}
    onFinish={updateProfileInformations}
    pageType="profile"
  />
</Modal>

    </>
  );
};

export default GeneralInfoes;
